import BLOCKS from './blocks';

import testUiData from '@constants/test.json';

/*const TestKeys = Object.keys(testUiData.testOptions);*/

const initialState = {
  [BLOCKS.APP.LOADED]: false,
  [BLOCKS.APP.POPUP]: '',

  [BLOCKS.RECON_PANELS.CURRENT_STEP]: -1,

  [BLOCKS.HISTORY_PANELS.CURRENT_LOCATION]: '',
  [BLOCKS.HISTORY_PANELS.CURRENT_SUBLOCATION]: '',

  [BLOCKS.MAP.OFFSET]: { x: 0, y: 0 },
  [BLOCKS.MAP.GLIDE_PARAMS]: { x: 0, y: 0 },
  [BLOCKS.MAP.CURSOR_POSITION]: { x: -1, y: -1 },
  [BLOCKS.MAP.PICKING_MARKER]: { x: -1, y: -1 },
  [BLOCKS.MAP.ACTIVE_MARKERS]: [{ x: -1, y: -1 }, { x: -1, y: -1 }],
  [BLOCKS.MAP.CROSSHAIR_SETTING]: -1,
  [BLOCKS.MAP.MARKER_COUNT]: 0,

  [BLOCKS.MINI_MAP.ZOOM]: 1,
  [BLOCKS.MINI_MAP.WITH_TREES]: false,
  [BLOCKS.MINI_MAP.WITH_LEGENDS]: false,

  [BLOCKS.MODE.VALUE]: 1,

  [BLOCKS.TEST_PANELS.ACTIVE_TEST]: '', //TestKeys[0],

  [BLOCKS.USER_INFO.BALANCE]: 0,
  [BLOCKS.USER_INFO.USERNAME]: ''
};

export default initialState;